<template>
    <div>
      <el-row style="margin: 20px;">
        <el-col :span="12">
          <el-table
            stripe
            :data="userdata"
            ref="multipleTable">
            <el-table-column
              prop="username"
              label="用户">
            </el-table-column>
            <el-table-column
              label="操作"
              width="120px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="选定用户" placement="top-start">
                  <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="setuser(scope.$index, userdata)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="12">
          <el-form ref="form"  label-width="120px" label-position="left">
            <el-input v-model="msg" placeholder="请输入内容"></el-input>
            <el-button style="margin-top: 10px; margin-left: 10px;" @click="sendmsg">发送消息</el-button>
          </el-form>
        </el-col>
      </el-row>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'KFMana',
    data () {
      return {
        userdata: [],
        msg: '',
        seldata: ''
      }
    },
    mounted () {
      that = this
      window.console.log(that)
      that.getuser()
      // that.initWebSocket()
    },
    methods: {
      initWebSocket() {
        const wsuri = 'ws://192.168.1.4:9001/conn/kf'
        window.console.log(wsuri)
        this.websock = new WebSocket(wsuri);
        this.websock.onmessage = this.websockonmessage;
        this.websock.onopen = this.websockonopen;
        this.websock.onerror = this.websockonerror;
        this.websock.onclose = this.websockclose;
      },
      websockonopen() {
        var userinfo = {
          username: 'kf',
          usertype: 'user',
          type: 'addkf'
        }
        this.websocketsend(JSON.stringify(userinfo));
      },
      websockonerror() {
        this.initWebSocket();
      },
      websockonmessage(e) {
        window.console.log(e.data);
      },
      websockclose() {
        window.console.log('连接中断');
      },
      websocketsend(Data){ // 数据发送
        this.websock.send(Data);
      },
      setuser (index,data) {
        that.seldata = data[index]
      },
      sendmsg () {
        var msginfo = {
          username: that.seldata.username,
          msgtype: 'to',
          type: 'tomsg',
          msg: this.msg
        }
        this.websocketsend(JSON.stringify(msginfo));
      },
      getuser () {
        that.$http({
          url: 'http://192.168.1.4:9001/getkfusers',
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.userdata = res.data
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/kf/KFMana.vue